<template>
    <div class="blacklist">

        <!-- Título / Breadcrumbs / Botões -->
        <mu-row justify-content="center" align-items="center">
            <mu-col span="8" sm="8" md="6" lg="6" xl="6">

                <!-- Título da página -->
                <mu-title color="secondary" textStrong="700">Contatos Bloqueados</mu-title>

                <!-- Breadcrumbs -->
                <mu-breadcrumbs divider="—">
                    <font-awesome-icon icon="chevron-right" slot="divider" class="icon-sm icon-margin-right"/>
                    <mu-breadcrumbs-item v-for="item in breadcrumbs" :key="item.text" :to="{ name: item.route }" :disabled="item.disabled">{{ item.text }}</mu-breadcrumbs-item>
                </mu-breadcrumbs>
            </mu-col>
            <mu-col span="4" sm="4" md="6" lg="6" xl="6">

                <!-- Submenu -->
                <div class="submenu">
                    <mu-menu cover placement="left-start" class="menu-mobile">
                        <mu-button icon>
                            <font-awesome-icon icon="ellipsis-v" class="icon-md"/>
                        </mu-button>
                        <mu-list slot="content" class="mu-list-custom">
                            <mu-list-item button color="primary" @click="openDialogSingle()">
                                <mu-list-item-title>Adicionar N.º</mu-list-item-title>
                                <mu-list-item-action><font-awesome-icon icon="plus" class="icon-md"/></mu-list-item-action>
                            </mu-list-item>
                            <mu-list-item button color="secondary" @click="openDialogMultiple()">
                                <mu-list-item-title>Importar CSV</mu-list-item-title>
                                <mu-list-item-action><font-awesome-icon icon="upload" class="icon-md"/></mu-list-item-action>
                            </mu-list-item>
                        </mu-list>
                    </mu-menu>
                    <div class="menu-desktop">
                        <mu-flex>
                            <mu-button round color="primary" @click="openDialogSingle()">
                                <font-awesome-icon icon="plus" class="icon-md icon-margin-left"/>
                                Adicionar N.º
                            </mu-button>
                            <mu-button round color="secondary" @click="openDialogMultiple()">
                                <font-awesome-icon icon="upload" class="icon-md icon-margin-left"/>
                                Importar CSV
                            </mu-button>
                        </mu-flex>
                    </div>
                </div>

            </mu-col>
        </mu-row>

        <!-- Busca -->
        <div class="search">
            <mu-paper :z-depth="1">
                <mu-row gutter>
                    <mu-col span="12" sm="12" md="2" lg="2" xl="2">
                        <mu-text-field v-model="filter.phone" full-width label="Telefone" @keyup.enter="filterRun()"></mu-text-field>
                    </mu-col>
                    <mu-col span="12" sm="12" md="4" lg="4" xl="4">
                        <mu-flex class="padding-top">
                            <mu-button round color="secondary" @click="filterRun()" class="mr-4">
                                <font-awesome-icon icon="search" class="icon-md icon-margin-left"/>
                                Filtrar
                            </mu-button>
                            <mu-button round @click="filterClear()">Limpar</mu-button>
                        </mu-flex>
                    </mu-col>
                </mu-row>
            </mu-paper>
        </div>

        <!-- Lista de contatos -->
        <div class="contacts" v-if="!contacts.loading">
            <mu-paper :z-depth="1">

                <!-- Listagem dos contatos tablet/desktop -->
                <mu-data-table :columns="contacts.columns" :data="contacts.list" v-if="viewport !== 'mobile'" class="mu-table-custom">
                    <template slot="empty">
                        <div class="box-table-empty">
                            Não foi encontrado registros.
                        </div>
                    </template>
                    <template slot-scope="scope">
                        <td>{{ scope.row.phone }}</td>
                        <td>{{ scope.row.optional }}</td>
                        <td>{{ dateFormat(scope.row.updated_at || scope.row.created_at, true) }}</td>
                        <td class="is-center">
                            <a href="javascript:;" @click="blacklist(scope.row.id, false)" class="remover">
                                <font-awesome-icon icon="trash" />
                            </a>
                        </td>
                    </template>
                </mu-data-table>

                <!-- Listagem de contatos mobile -->
                <mu-list textline="three-line" v-if="viewport === 'mobile'">
                    <span v-for="(item, key) in contacts.list" :key="key">
                        <mu-list-item>
                            <mu-list-item-content>
                                <mu-list-item-sub-title>
                                    {{ item.phone }}
                                </mu-list-item-sub-title>
                            </mu-list-item-content>
                            <mu-list-item-action>
                                <a href="javascript:;" @click="blacklist(item.id, false)" class="remover">
                                    <font-awesome-icon icon="trash" />
                                </a>
                            </mu-list-item-action>
                        </mu-list-item>
                        <mu-divider></mu-divider>
                    </span>
                </mu-list>
            </mu-paper>

            <!-- Paginação -->
            <mu-flex class="paginate" justify-content="center" v-if="contacts.paging.total > contacts.paging.size">
                <mu-pagination :total="contacts.paging.total" :page-count="5" :page-size="contacts.paging.size" :current.sync="contacts.paging.page" @change="load()"></mu-pagination>
            </mu-flex>
        </div>

        <!-- Loading -->
        <mu-loading text="Carregando sua lista de contatos bloqueados" v-if="contacts.loading"></mu-loading>

        <!-- Dialog Single -->
        <mu-dialog title="Adicionar 1 telefone" width="500" :open.sync="dialog.single.open">
            <mu-text-field v-model="dialog.single.phone" full-width label="Telefone *"></mu-text-field>
            <mu-text-field v-model="dialog.single.optional" label="Motivo" full-width multi-line :rows="3"></mu-text-field>
            <mu-button round color="primary" class="mr-4" @click="saveSingle()" :disabled="!dialog.single.phone">Salvar</mu-button>
            <mu-button round @click="dialog.single.open = false">Cancelar</mu-button>
        </mu-dialog>

        <!-- Dialog Multiple -->
        <mu-dialog title="Importar CSV" width="500" :open.sync="dialog.multiple.open">
            <mu-alert>
                <p><strong>Atenção:</strong> O arquivo CSV deve conter apenas a primeira coluna com o número a qual deseja adicionar na "Lista Contatos Bloqueados".</p>
            </mu-alert>
            <mu-text-field v-model="dialog.multiple.optional" full-width label="Motivo" multi-line :rows="3"></mu-text-field>
            <div class="upload">
                <div v-if="!dialog.multiple.form.file">
                    <input type="file" ref="file" class="input-file" @change="handleFileUpload">
                    <font-awesome-icon icon="upload" size="2x" />
                    <h3 class="title">Selecione ou arraste aqui o arquivo</h3>
                    <p>Formatos permitidos: CSV</p>
                </div>
                <div v-else class="description">
                    <font-awesome-icon icon="paperclip" size="2x" />
                    <p>O arquivo <strong>{{ dialog.multiple.form.file.name }}</strong> possui o tamanho de <strong>{{ dialog.multiple.form.file.size }}</strong> kbytes</p>
                    <mu-button @click="removeFile()" round color="red">Remover Arquivo</mu-button>
                </div>
            </div>
            <mu-button round color="primary" class="mr-4" @click="saveMultiple()" :disabled="!dialog.multiple.form.file">Importar</mu-button>
            <mu-button round @click="dialog.multiple.open = false">Cancelar</mu-button>
        </mu-dialog>

    </div>
</template>

<script>
    import BlacklistServices from '@/services/contacts/blacklist'

    export default {
        name: 'app-blacklist-dashboard',

        // ╔╦╗╔═╗╔╦╗╔═╗
        //  ║║╠═╣ ║ ╠═╣
        // ═╩╝╩ ╩ ╩ ╩ ╩

        data () {
            return {
                breadcrumbs: [
                    {
                        text: 'Contatos',
                        route: 'app.contacts',
                        disabled: false
                    },
                    {
                        text: 'Contatos Bloqueados',
                        disabled: true
                    }
                ],
                filter: {
                    phone: ''
                },
                dialog: {
                    single: {
                        open: false,
                        phone: ''
                    },
                    multiple: {
                        open: false,
                        form: {
                            file: ''
                        }
                    }
                },
                contacts: {
                    loading: false,
                    paging: {
                        total: 0,
                        size: 10,
                        page: 1
                    },
                    columns: [
                        { title: 'Telefone', name: 'phone' },
                        { title: 'Motivo', name: 'optional' },
                        { title: 'Última atualização', name: 'updated_at' },
                        { title: 'Retirar da Lista Contatos Bloqueados', name: 'remove', align: 'center' }
                    ],
                    list: []
                }
            }
        },

        // ╔═╗╦═╗╔═╗╔═╗╔╦╗╔═╗╔╦╗
        // ║  ╠╦╝║╣ ╠═╣ ║ ║╣  ║║
        // ╚═╝╩╚═╚═╝╩ ╩ ╩ ╚═╝═╩╝

        /**
         * Acessamos o load para carregar a lista de contato assim que
         * o componente é montado
         */
        async created () {
            await this.load()
        },

        // ╔╦╗╔═╗╔╦╗╦ ╦╔═╗╔╦╗╔═╗
        // ║║║║╣  ║ ╠═╣║ ║ ║║╚═╗
        // ╩ ╩╚═╝ ╩ ╩ ╩╚═╝═╩╝╚═╝

        methods: {

            /**
             * Carrega a lista de contatos passando alguns filtros relacionados
             * a busca e paginação
             */
            async load () {
                try {
                    this.contacts.loading = true

                    let query = {
                        page: this.contacts.paging.page
                    }
                    if (this.filter.phone) {
                        query.phone = this.filter.phone
                    }

                    let result = await BlacklistServices.all(query)

                    if (result && result.status) {
                        this.contacts.paging.page = result.currentPage
                        this.contacts.paging.total = result.rowCount
                        this.contacts.list = result.results
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível carregar os dados.')
                } finally {
                    this.contacts.loading = false
                }
            },

            /**
             * Gatilho para atualizar o campo blacklist do contato
             */
            async blacklist (id, blacklist) {
                try {
                    let result = await BlacklistServices.update({
                        id,
                        blacklist
                    })

                    if (result && result.status) {
                        if (this.contacts.list.length === 1) {
                            this.contacts.paging.page = this.contacts.paging.page > 1 ? this.contacts.paging.page - 1 : 1
                            this.contacts.paging.total = 10
                        }
                        this.load()
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível atualizar a lista de contatos bloqueados.')
                }
            },

            async saveSingle () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde... Adicionando o número a lista contatos bloqueados.')

                    let result = await BlacklistServices.single({
                        phone: this.dialog.single.phone,
                        optional: this.dialog.single.optional
                    })

                    if (result && result.status) {
                        this.dialog.single.open = false
                        this.dialog.single.phone = ''
                        this.dialog.single.optional = ''
                        this.load()
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível salvar o contato na lista contatos bloqueados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            async saveMultiple () {
                try {
                    this.$eventHub.$emit('loading', true, 'Aguarde... Importando números para lista contatos bloqueados.')

                    let result = await BlacklistServices.multiple({
                        file: this.dialog.multiple.form.file,
                        optional: this.dialog.multiple.optional
                    })

                    if (result && (result.status === 400 || result.status === 415)) {
                        for (const key in result.errors) {
                            if (result.errors.hasOwnProperty(key)) {
                                const element = result.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element[0], false)
                                return
                            }
                        }
                        return
                    } else if (result && result.status) {
                        this.dialog.multiple.open = false
                        this.dialog.multiple.form.file = ''
                        this.dialog.multiple.optional = ''
                        this.load()
                        return
                    } else if (result.code === 422) {
                        for (const key in result.results.errors) {
                            if (result.results.errors.hasOwnProperty(key)) {
                                const element = result.results.errors[key]
                                this.$eventHub.$emit('snackbar', 'error', element.message, false)
                                return
                            }
                        }
                        return
                    }

                    throw Error(result.message)
                } catch (e) {
                    this.$eventHub.$emit('snackbar', 'error', e.message || 'Não foi possível importar para lista de contatos bloqueados.')
                } finally {
                    this.$eventHub.$emit('loading', false)
                }
            },

            filterRun () {
                this.contacts.paging.page = 1
                this.contacts.paging.size = 10
                this.load()
            },

            filterClear () {
                this.filter = {
                    phone: ''
                }
                this.contacts.paging.page = 1
                this.contacts.paging.size = 10
                this.load()
            },

            openDialogSingle () {
                this.dialog.single.open = true
                this.dialog.single.phone = ''
                this.dialog.single.optional = ''
            },

            openDialogMultiple () {
                this.dialog.multiple.open = true
                this.dialog.multiple.form.file = ''
                this.dialog.multiple.optional = ''
            },

            /**
             * Adiciona o arquivo e faz uma validação da extensão
             */
            handleFileUpload () {
                this.dialog.multiple.form.file = this.$refs.file.files[0]
                let extension = this.dialog.multiple.form.file.name.split('.').pop()
                let extensionsPossibles = ['CSV']
                if (!extensionsPossibles.includes(extension.toUpperCase())) {
                    this.$eventHub.$emit('snackbar', 'error', `A extensão do arquivo não é permitido (.${extension.toUpperCase()}).`)
                    this.dialog.multiple.form.file = ''
                }
            },

            /**
             * Remove o arquivo
             */
            async removeFile (e) {
                this.dialog.multiple.form.file = ''
            }
        },

        // ╔═╗╔═╗╔╦╗╔═╗╦ ╦╔╦╗╔═╗╔╦╗
        // ║  ║ ║║║║╠═╝║ ║ ║ ║╣  ║║
        // ╚═╝╚═╝╩ ╩╩  ╚═╝ ╩ ╚═╝═╩╝

        computed: {

            /**
             * Utilizado para verificar se o acesso é de desktop, table ou mobile
             */
            viewport () {
                return this.$currentViewport.label
            }
        }
    }
</script>

<style lang="stylus" scoped>

    @import './../../../../assets/stylus/bootstrap.styl'

    .blacklist

        .mr-4
            margin-right 4px

        .search
            text-align center
            margin 20px 0

            .row
                .mu-input
                    margin-bottom 0

            .mu-paper
                padding 10px 20px 20px 20px

            .padding-top
                padding-top 28px

        a.remover:hover
            color $red

        .paginate
            padding 20px

        .mu-paper
            padding 0px

    .upload
        width 100%
        padding 20px
        background lighten($grey, 70%)
        border 1px $grey solid
        color darken($grey, 30%)
        text-align center
        position relative
        overflow hidden
        display inline-block
        border-radius 5px
        margin-bottom 20px

        &:hover
            background lighten($grey, 50%)

        .title
            margin 0

        p
            margin 0

        .description
            padding-top 20px

            span
                padding 0 5px

        input[type='file']
            border 0
            width 100%
            z-index 200
            cursor pointer
            position absolute
            left 0
            top 0
            bottom 0
            opacity 0

    .text-primary
        color $primary

    .submenu
        float right

        .mu-button
            margin-left 5px

    /* Tablet >= 768 pixels */
    @media (min-width: 768px)
        .search
            text-align left !important
</style>
